<template>
  <div class="app-container">
    <div class="app-content">
      <div
        v-loading="isLoading"
        class="weather-home"
        element-loading-text="数据加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <!-- 设备详情 -->
        <el-card class="box-card base-info__card">
          <template #header>
            {{ $t('text.sbxx') }}
          </template>
          <template #default>
            <el-descriptions title="" :column="1">
              <el-descriptions-item :label="$t('text.mc')">{{ queryParams.orgname }}</el-descriptions-item>
              <el-descriptions-item :label="$t('text.sbh')">{{ queryParams.gatewaysn }}</el-descriptions-item>
              <el-descriptions-item :label="$t('text.zt')">{{ queryParams.status | StatusFilter }}</el-descriptions-item>
              <el-descriptions-item :label="$t('text.gxsj')">{{ queryParams.sitetime }}</el-descriptions-item>
            </el-descriptions>
          </template>
        </el-card>
        <!-- 湿度 -->
        <el-card class="box-card">
          <template #header>
            {{ $t('text.sd') }}
          </template>
          <template #default>
            <LineChart
              :data="humidity.data"
              :columns="humidity.columns"
              :setting="humidity.setting"
              :extend="humidity.extend"
              :format="humidity.format"
              style="height:100%"
            />
          </template>
        </el-card>
        <!-- 风速 -->
        <el-card class="box-card wind-speed__card">
          <template #header>
            {{ $t('text.fengs') }}
          </template>
          <template #default>
            <LineChart
              :data="windspeed.data"
              :columns="windspeed.columns"
              :setting="windspeed.setting"
              :extend="windspeed.extend"
              :format="windspeed.format"
              :unit="windspeed.unit"
              :loading="isLoading"
              style="height:100%"
            />
          </template>

        </el-card>
        <!-- 风向 -->
        <el-card class="box-card wind-direction_card">
          <template #header>
            {{ $t('text.fx') }}
            <el-button style="float: right; padding: 3px 0; color: white;cursor: default" type="text">
              <span>{{ $t('text.dqfx') }}</span>
              <span style="color:#f79124;margin-left: 15px;">{{ queryParams.windesc }}{{ queryParams.windirection
              }}°</span>
            </el-button>
          </template>
          <template #default>
            <div class="text">
              <div class="airchart-chart">
                <div
                  v-for="item in airchart.wind"
                  :key="item.angle"
                  :style="{ transform: `rotateZ(${item.angle}deg) translateY(-${item.distance}px)` }"
                  class="item-tick"
                >
                  <span :style="{ transform: `rotateZ(-${item.angle}deg)` }">
                    {{ item.direction }} {{ item.angle }}°
                  </span>
                </div>
                <div
                  class="item-tick_active"
                  :style="{ transform: `rotateZ(${airchart.windirection}deg) translateY(-110px)` }"
                />
                <div class="value">当前:{{ airchart.windirection }}°</div>
              </div>
            </div>
          </template>
        </el-card>
        <!-- 气压 -->
        <el-card class="box-card">
          <template #header>
            {{ $t('text.qy') }}
            <el-button style="float: right; padding: 3px 0; color: white;cursor: default" type="text">
              <span>{{ $t('text.dqqy') }}:{{ (queryParams.airpressure / 10).toFixed(2) | unit('kpa') }}</span>
            </el-button>
          </template>
          <template #default>
            <div ref="chart" style="height:100%; pointer-events: none;" />
          </template>
        </el-card>
        <!-- 雨强 -->
        <el-card class="box-card" style="grid-column: span 3;">
          <template #header>
            雨强
          </template>
          <template #default>
            <LineChart
              :data="rainstrength.data"
              :columns="rainstrength.columns"
              :setting="rainstrength.setting"
              :extend="rainstrength.extend"
              :format="rainstrength.format"
              style="height:100%"
            />
          </template>
        </el-card>
        <!-- 总辐射 -->
        <el-card class="box-card" style="grid-column: span 3;">
          <template #header>
            总辐射
          </template>
          <template #default>
            <LineChart
              :data="sunshine.data"
              :columns="sunshine.columns"
              :setting="sunshine.setting"
              :extend="sunshine.extend"
              :format="sunshine.format"
              style="height:100%"
            />
          </template>
        </el-card>
        <!-- 雨量 -->
        <el-card class="box-card">
          <template #header>
            雨量
          </template>
          <template #default>
            <LineChart
              :data="rain.data"
              :columns="rain.columns"
              :setting="rain.setting"
              :extend="rain.extend"
              :format="rain.format"
              :unit="rain.unit"
              :loading="isLoading"
              style="height:100%"
            />
          </template>
        </el-card>
        <!-- 温度 -->
        <el-card class="box-card" style="grid-column: span 6;">
          <template #header>
            温度/贴片温度
          </template>
          <template #default>
            <LineChart
              :data="temperaturedata.data"
              :columns="temperaturedata.columns"
              :setting="temperaturedata.setting"
              :extend="temperaturedata.extend"
              :format="temperaturedata.format"
              style="height:100%"
            />
          </template>
        </el-card>
      </div>
    </div>
  </div>
</template>
<script>
import { GetWeatherDetailsByGatewayId } from '@/api/Weather'
import { QueryWeathereReals } from '@/api/Weather'
import LineChart from '@/components/Charts/LineChart.vue'
import * as echart from 'echarts'
import { combineData } from '@utils'
import dayjs from 'dayjs'
export default {
  name: 'Weather',
  components: {
    LineChart,
  },
  filters: {
    StatusFilter (st) {
      if (st === '0') {
        return '正常'
      }
      if (st === '2') {
        return '离线'
      }
    }
  },
  data () {
    return {
      isLoading: false,
      queryParams: {
        orgid: this.$store.getters.station.id
      },
      airpressure: {
        series: [
          {
            type: 'gauge',
            max: 1000,
            itemStyle: {
              color: '#ffffff',
            },
            pointer: {
              length: '85%',
              width: 10,
              offsetCenter: [0, 0],
              showAbove: false
            },
            axisLine: {
              lineStyle: {
                width: 3,
                color: [[1, '#1ee6e6']]
              }
            },
            splitLine: {
              show: false,
            },
            axisTick: {
              length: 10,
              lineStyle: {
                width: 1,
                color: '#fff'
              }
            },
            axisLabel: {
              distance: -10,
              color: '#fff',
            },
            title: {
              show: false
            },
            radius: '100%',
            detail: {
              show: false
            },
            data: [
              {
                value: 0,
              }
            ]
          }
        ]
      },
      sunshine: {
        data: [],
        columns: ['time', 'val1'],
        setting: { labelMap: { val1: '日照辐射' }},
        format: ['hh:mm'],
        unit: 'msv',
        extend: {
          color: '#13b5b1',
          legend: {
            show: false
          },
          grid: {
            right: 0,
            left: 20,
            bottom: 10,
            top: 35
          },
          tooltip: {
            formatter: (params) => `${params[0].value[0]}<br/> ${params[0].marker} ${params[0].seriesName}：${params[0].value[1]}msv`
          },
          xAxis: {
            axisLine: {
              lineStyle: {
                color: '#ffffff'
              }
            }
          },
          yAxis: {
            name: 'msv',
            position: 'left',
            axisLine: {
              lineStyle: {
                color: '#ffffff'
              }
            }
          },
          series: {
            showSymbol: false,
            smooth: true,
          }
        }
      },
      rainstrength: {
        data: [],
        columns: ['time', 'val1'],
        setting: { labelMap: { val1: '雨强' }},
        unit: 'mm/h',
        extend: {
          color: '#ec6941',
          legend: {
            show: false
          },
          grid: {
            right: 0,
            left: 20,
            bottom: 10,
            top: 35
          },
          tooltip: {
            formatter: (params) => `${params[0].value[0]}<br/> ${params[0].marker} ${params[0].seriesName}：${params[0].value[1]}mm/h`
          },
          xAxis: {
            axisLine: {
              lineStyle: {
                color: '#ffffff'
              }
            }
          },
          yAxis: {
            name: 'mm/h',
            position: 'left',
            axisLine: {
              lineStyle: {
                color: '#ffffff'
              }
            }
          },
          series: {
            showSymbol: false,
            smooth: true,
          }
        }
      },
      rain: {
        data: [],
        columns: ['time', 'val1'],
        setting: { labelMap: { val1: '降雨量' }},
        format: ['hh:mm'],
        unit: 'mm',
        extend: {
          color: '#8957a1',
          legend: {
            show: false
          },
          grid: {
            right: 0,
            left: 20,
            bottom: 10,
            top: 35
          },
          tooltip: {
            formatter: (params) => `${params[0].value[0]}<br/> ${params[0].marker} ${params[0].seriesName}：${params[0].value[1]}mm`
          },
          xAxis: {
            axisLine: {
              lineStyle: {
                color: '#ffffff'
              }
            }
          },
          yAxis: {
            name: 'mm',
            position: 'left',
            axisLine: {
              lineStyle: {
                color: '#ffffff'
              }
            }
          },
          series: {
            showSymbol: false,
            smooth: true,
          }
        }
      },
      windspeed: {
        data: [],
        columns: ['time', 'val1'],
        setting: { labelMap: { val1: '风速' }},
        format: ['hh:mm'],
        unit: 'm/s',
        extend: {
          color: '#5660a3',
          legend: {
            show: false
          },
          grid: {
            right: 0,
            left: 20,
            bottom: 10,
            top: 35
          },
          tooltip: {
            formatter: (params) => `${params[0].value[0]}<br/> ${params[0].marker} ${params[0].seriesName}：${params[0].value[1]}m/s`
          },
          xAxis: {
            axisLine: {
              lineStyle: {
                color: '#ffffff'
              }
            }
          },
          yAxis: {
            name: 'm/s',
            position: 'left',
            axisLine: {
              lineStyle: {
                color: '#ffffff'
              }
            }
          },
          series: {
            showSymbol: false,
            smooth: true,
          }
        }
      },
      temperaturedata: {
        setting: {
          labelMap: {
            temperature: '温度',
            pathtemper: '贴片温度'
          }
        },
        format: ['hh:mm'],
        data: [],
        extend: {
          color: ['#ec6941', '#5660a3'],
          grid: {
            right: 0,
            left: 20,
            bottom: 10,
            top: 35
          },
          legend: {
            textStyle: {
              color: '#ffffff'
            },
            itemStyle: {
              decal: {
                symbol: 'pin'
              }
            }
          },
          tooltip: {
            formatter: (params) => `${params[0].value[0]}<br/>
                                    ${params[0].marker} ${params[0].seriesName}：${params[0].value[1]}℃<br/> 
                                    ${params[1].marker} ${params[1].seriesName}：${params[1].value[1]}℃`
          },
          xAxis: {
            axisLine: {
              lineStyle: {
                color: '#ffffff'
              }
            }
          },
          yAxis: {
            name: '℃',
            position: 'left',
            axisLine: {
              lineStyle: {
                color: '#ffffff'
              }
            }
          },
          series: {
            showSymbol: false,
            smooth: true,
          }
        },
        columns: ['time', 'temperature', 'pathtemper']
      },
      airchart: {
        windirection: 0,
        windesc: '',
        wind: [
          {
            angle: 0,
            direction: '北',
            distance: 130,
            descriptAngle: 0,
          },
          {
            angle: 45,
            direction: '东北',
            distance: 138,
            descriptAngle: 0,
          },
          {
            angle: 90,
            direction: '东',
            distance: 138,
            descriptAngle: 0,
          },
          {
            angle: 135,
            direction: '东南',
            distance: 138,
            descriptAngle: 0,
          },
          {
            angle: 180,
            direction: '南',
            distance: 130,
            descriptAngle: 0,
          },
          {
            angle: 225,
            direction: '西南',
            distance: 138,
            descriptAngle: 0,
          },
          {
            angle: 270,
            direction: '西',
            distance: 138,
            descriptAngle: 0,
          },
          {
            angle: 315,
            direction: '西北',
            distance: 138,
            descriptAngle: 0,
          }
        ]
      },
      humidity: {
        setting: {
          labelMap: {
            val1: '湿度'
          }
        },
        data: [],
        extend: {
          color: '#2a836a',
          legend: {
            show: false
          },
          grid: {
            right: 0,
            left: 20,
            bottom: 10,
            top: 35
          },
          tooltip: {
            formatter: (params) => `${params[0].value[0]}<br/> ${params[0].marker} ${params[0].seriesName}：${params[0].value[1]}%rh`
          },
          xAxis: {
            axisLine: {
              lineStyle: {
                color: '#ffffff'
              }
            }
          },
          yAxis: {
            name: '%rh',
            position: 'left',
            axisLine: {
              lineStyle: {
                color: '#ffffff'
              }
            }
          },
          series: {
            showSymbol: false,
            smooth: true,
          }
        },
        columns: ['time', 'val1']
      }
    }
  },
  mounted () {
    this.getWeatherData()
  },
  methods: {
    /** 获取天气数据 */
    getWeatherData () {
      this.isLoading = true
      QueryWeathereReals({
        page: 1,
        perpage: 10,
        orderBy: '',
        whereCondition: JSON.stringify(this.queryParams)
      }).then(({ data }) => {
        if (data.queryResults && data.queryResults[0].gatewayid) {
          this.queryWeathereRealsCall(data.queryResults[0].gatewayid)
        } else {
          this.isLoading = false
        }
      }).catch(() => {
        this.isLoading = false
        this.$message({
          message: '获取天气数据失败',
          type: 'error'
        })
      })
    },

    /** 天气实时数据回调 */
    queryWeathereRealsCall (gatewayid) {
      GetWeatherDetailsByGatewayId({ id: gatewayid }).then(res => {
        this.formateTime(res.data)
        this.queryParams = res.data || []
        this.sunshine.data = res.data.sunshine || []
        this.humidity.data = res.data.humidity || []
        this.windspeed.data = res.data.windspeed || []
        this.rainstrength.data = res.data.rainstrength || []
        this.rain.data = res.data.rain || []
        this.setTemperaturedata(res)
        this.setAirChart(res)
        this.setAirPressure(res)
      }).then(() => {
        this.isLoading = false
      }).catch(() => {
        this.isLoading = false
        this.$message({
          message: '获取天气数据失败',
          type: 'error'
        })
      })
    },

    /**
    * 获取时间回调
    * @param param0
    */
    formateTime ({ humidity, windspeed, rainstrength, sunshine, rain }) {
      if (humidity && humidity.length > 0) {
        humidity.map(item => {
          item.time = dayjs(item.time).format('HH:mm:ss')
        })
      }
      if (windspeed && windspeed.length > 0) {
        windspeed.map(item => {
          item.time = dayjs(item.time).format('HH:mm:ss')
        })
      }
      if (rainstrength && rainstrength.length > 0) {
        rainstrength.map(item => {
          item.time = dayjs(item.time).format('HH:mm:ss')
        })
      }
      if (sunshine && sunshine.length > 0) {
        sunshine.map(item => {
          item.time = dayjs(item.time).format('HH:mm:ss')
        })
      }
      if (rain && rain.length > 0) {
        rain.map(item => {
          item.time = dayjs(item.time).format('HH:mm:ss')
        })
      }
    },

    /** 设置贴片温度 */
    setTemperaturedata (res) {
      const data = []
      Object.keys(res.data).forEach(key => {
        if (key === 'pathtemper' || key === 'temperature') {
          if (res.data[key]) {
            res.data[key].forEach(v => {
              v[key] = v.val1
              delete v.val1
              data.push(v)
            })
          }
        }
      })
      const temperaturedata = combineData(data, 'time')
      if (temperaturedata && temperaturedata.length > 0) {
        temperaturedata.map(item => { item.time = dayjs(item.time).format('HH:mm:ss') })
      }
      this.temperaturedata.data = temperaturedata
    },

    /** 设置风向 chart */
    setAirChart (res) {
      this.airchart.windirection = res.data.windirection
      this.airchart.windesc = res.data.windesc
    },

    /** 设置气压 */
    setAirPressure (res) {
      this.airpressure.series[0].data[0].value = (res.data.airpressure / 10).toFixed(2)
      const mychart = echart.init(this.$refs.chart)
      mychart.setOption(this.airpressure)
    }
  }
}
</script>

<style scoped>
.app-content{
  overflow: auto;
}

.weather-home {
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  grid-template-rows: repeat(3, 350px);
  grid-gap: 15px;
}

.weather-home .box-card {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-color: var(--card-bg-color);
  border-color: var(--card-bg-color);
  grid-column: span 2;
}

.weather-home .box-card >>>.el-card__header {
  width: 100%;
  height: 40px;
  padding: 0 15px 0 25px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: white;
  border-bottom: none;
  position: relative;
}
.weather-home .box-card >>>.el-card__header::before {
  display: block;
  content: '';
  width: 5px;
  height: 25px;
  border-radius: 5px;
  background-color: var(--primary-color);
  margin-right: 10px;
  position: absolute;
  top: 7px;
  left: 15px;
}

.weather-home .box-card >>> .el-card__body {
  width: 100%;
  height: calc(100% - 40px);
  padding: 15px;
  box-sizing: border-box;
}

.weather-home .base-info__card >>>.el-card__body .el-descriptions {
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  color: white;
}
.weather-home .base-info__card >>>.el-card__body .el-descriptions .el-descriptions__body{
  background-color: var(--card-bg-color);
}
.weather-home .base-info__card >>>.el-card__body .el-descriptions .el-descriptions__body .el-descriptions-item__label{
  width: 100px;
}
.weather-home .base-info__card >>>.el-card__body .el-descriptions .el-descriptions__body .el-descriptions-item__label,
.weather-home .base-info__card >>>.el-card__body .el-descriptions .el-descriptions__body .el-descriptions-item__content {
  color: white;
}

.weather-home .wind-speed__card >>>.el-card__body .v-charts-component-loading {
  background-color: var(--card-bg-color);
}

.weather-home .wind-direction_card >>>.el-card__body {
  position: relative;
}
.weather-home .wind-direction_card >>>.el-card__body .airchart-chart {
  height: 220px;
  width: 220px;
  box-sizing: border-box;
  border-radius: 50%;
  background-color: transparent;
  border: 2px solid #2e4272;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}
.weather-home .wind-direction_card >>>.el-card__body .airchart-chart>.item-tick {
  height: 30px;
  width: 30px;
  box-sizing: border-box;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: smaller;
}
.weather-home .wind-direction_card >>>.el-card__body .airchart-chart>.item-tick>span {
  text-wrap-mode: nowrap;
  color: white;
}
.weather-home .wind-direction_card >>>.el-card__body .airchart-chart>.item-tick_active {
  height: 10px;
  width: 10px;
  box-sizing: border-box;
  background-color: #f79124;
  border-radius: 50%;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}
.weather-home .wind-direction_card >>>.el-card__body .airchart-chart>.value {
  height: 10px;
  width: 100px;
  box-sizing: border-box;
  color: #f79124;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: larger;
}
</style>
